import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { RoutingInfo } from "#/types/routingInfo"
import { Journey } from "#/components/carrot-plans/types/journey"
import { useFlags } from "launchdarkly-react-client-sdk"
export default function MostHelpfulDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const { pregnancyAndPostpartumUpdatedRouting } = useFlags()

  function getMemberSelectsValue(routingData: RoutingInfo): string {
    const journey = routingData?.journey
    const journeysToSeeDoAnyApply = [
      Journey.TRY_PREGNANT,
      Journey.ASSISTED_REPRODUCTION,
      Journey.PRESERVATION,
      Journey.EXPLORING
    ]
    const journeysShouldNotSeeDoAnyApply = [
      Journey.MENOPAUSE,
      Journey.LOW_TESTOSTERONE,
      Journey.GENDER_AFFIRMING_CARE,
      Journey.PREGNANT,
      Journey.GESTATIONAL
    ]
    const skipMedicalQuestionsForJourney: boolean = journey === Journey.PARENTING
    const skipMedicalQuestionsForJourneyStage: boolean =
      routingData?.journeyStage === "POSTPARTUM" && !pregnancyAndPostpartumUpdatedRouting

    if (journeysToSeeDoAnyApply.includes(journey as Journey)) {
      return "DO_ANY_APPLY"
    }

    if (skipMedicalQuestionsForJourney || skipMedicalQuestionsForJourneyStage) {
      return "ANYTHING_ELSE"
    }

    if (journeysShouldNotSeeDoAnyApply.includes(journey as Journey)) {
      return journey
    }

    return "OTHER_ANSWERS"
  }

  const { send } = useStateMachine()
  useEffect(() => {
    send(getMemberSelectsValue(routingData))
  })
  return <></>
}
